export enum GROUPS {
  workspace = 'workspace.stack.io',
  workspacerole = 'workspacerole.stack.io',
  iam = 'iam.stack.io',
  confcenter = 'confcenter.stack.io',
  audit = 'audit.stack.io',
  log = 'log.stack.io',
  alertmanager = 'alertmanager.stack.io',
  monitor = 'monitor.stack.io',
  image = 'image.stack.io',
  computing = 'computing.stack.io',
  storage = 'storage.k8s.io',
  datacenter = 'datacenter.stack.io',
  deployment = 'deployment.stack.io',
  statefulset = 'statefulset.stack.io',
  dc = 'dc.stack.io',
  subcluster = 'subcluster.stack.io',
  clusterinfo = 'clusterinfo.stack.io',
  clusterrole = 'clusterrole.stack.io',
  namespace = 'namespace.stack.io',
  configmap = 'configmap.stack.io',
  secret = 'secret.stack.io',
  ctrinstance = 'ctrinstance.stack.io',
  apps = 'apps',
  registry = 'registry.stack.io',
  network = 'network.stack.io',
  persistentvolumeclaim = 'persistentvolumeclaim.stack.io',
  vpn = 'vpn.stack.io',
  pod = 'pod.stack.io',
  node = 'node.stack.io',
  clusterScheduler = 'cluster.scheduler.stack.io',
  service = 'service.stack.io',
  persistentvolume = 'persistentvolume.stack.io',
  daemonset = 'daemonset.stack.io',
  autoscaling = 'autoscaling',
  datareport = 'datareport.stack.io',
  cluster = 'cluster.stack.io',
  yourself = 'yourself.stack.io',
  perception = 'perception.stack.io',
  ophub = 'ophub.stack.io',
  terminal = 'terminal.stack.io',
  screen = 'screen.stack.io',
  dashboardmonitor = 'dashboardmonitor.stack.io',
  monitoring = 'monitoring.stack.io',
  /** 集群监控（infra）：如弹性裸金属 metrics / 详情监控 Tab */
  monitoringInfra = 'monitoring.infra.stack.io',
  storageStack = 'storage.stack.io',
  notice = 'notice.stack.io',
  kubernetes = 'kubernetes.stack.io',
  maas = 'core.maas.stack.io',
  /** 模型实例 API group。 */
  inferenceMaas = 'inference.maas.stack.io',
  /** 模型训练任务与训练集群 API group。 */
  trainingMaas = 'training.maas.stack.io',
  subMaas = 'subs.maas.stack.io',
  llmgw = 'llmgw.maas.stack.io',
  proxyCluster = 'proxy.cluster.stack.io',
}
